import React, { useState } from 'react';
import Select from 'react-select';
import { Country, State, City } from 'country-state-city';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { Link, useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


type OptionType = {
  value: string;
  label: string;
};

type Props = {
  className: string;
};

const HubPoint: React.FC<Props> = ({ className }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [location, setLocation] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [success, setSuccess] = useState(false);
  const history = useHistory()




  const handleCountryChange = (selectedOption: OptionType | null) => {
    setCountry(selectedOption ? selectedOption.value : '');
    setState('');
    setCity('');
  };

  const handleStateChange = (selectedOption: OptionType | null) => {
    setState(selectedOption ? selectedOption.value : '');
    setCity('');
  };

  const handleCityChange = (selectedOption: OptionType | null) => {
    setCity(selectedOption ? selectedOption.value : '');
  };

  const countries = Country.getAllCountries().map(c => ({
    value: c.isoCode,
    label: c.name
  }));

  const states = country
    ? State.getStatesOfCountry(country).map(s => ({
      value: s.isoCode,
      label: s.name
    }))
    : [];

  const cities = state
    ? City.getCitiesOfState(country, state).map(c => ({
      value: c.name,
      label: c.name
    }))
    : [];

  const resetForm = () => {
    setName('');
    setType('');
    setAddress('');
    setCountry('');
    setState('');
    setCity('');
    setLocation('');

    setFormKey(formKey + 1);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    // if (!name.trim()) {
    //   setLoading(false);
    //   return toast.error('Name cannot be empty');
    // }

    // if (!address.trim() || /[^a-zA-Z\s]/.test(address)) {
    //   setLoading(false);
    //   return toast.error('address cannot be empty');
    // }

    // if (!location.trim() || /[^a-zA-Z\s]/.test(location)) {
    //   setLoading(false);
    //   return toast.error('location cannot be empty');
    // }


    const formData = {
      name,
      address,
      country,
      city,
      location,
      type,
      state
    };

    try {
      const response = await fetch('https://backendcway.causewaycargo.com/superadmin/creathuborfranchisees', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        resetForm();
        setSuccess(true);
        setTimeout(() => history.push('/hubtable'), 3000);
      } else {
        toast.error(result.message || 'An unexpected error occurred');
      }
    } catch (error) {
      console.error('Error creating hub:', error);
      toast.error('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className={` bg-white py-12 px-6 ${className}`}>
        <form key={formKey} onSubmit={handleSubmit}>
          <div>
            <h3 className='pb-6'>
              <span className='fw-bolder fs-3 mb-1'>Create Hub</span>
            </h3>
          </div>
          <div className="row mb-2">
            <div className="col-md-4 mb-3">
              <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
              <input
                type="text"
                id="name"
                className="form-control"
                value={name}
                autoComplete="on" // Allow autocomplete suggestions
                onKeyDown={(e) => {
                  if (e.key === " " && name.length === 0) {
                    e.preventDefault();
                  }
                  if ([
                    '+', '-', '.', '=', '_', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')',
                    '[', ']', '{', '}', '|', '/', '?', '<', '>', ',', '`', '~', "'", '"', ':', ';', '\\',
                    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
                  ].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setName(e.target.value)}
                required
              />


            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="address" className="form-label">Address <span className="text-danger">*</span></label>
              <input
                type="text"
                id="address"
                className="form-control"
                value={address}
                onKeyDown={(e) => {
                  if (e.key === " " && address.length === 0) {
                    e.preventDefault();
                  }

                  const blockedKeys = ['%', '*', '$', '@', '!', '(', ')', '=', '+', '^', '_', ':', ';', '"', "'", '<', '>', '/', '\\', '{', '}', '[', ']', '|', ',', '`'];
                  if (blockedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setAddress(e.target.value)}
                required
              />

            </div>

            <div className="col-md-4 mb-3">
              <label htmlFor="type" className="form-label">Type <span className="text-danger">*</span></label>
              <select
                id="type"
                className="form-select"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">Select Option</option>
                <option value="Franchisees">Franchisees</option>
                <option value="Hub">Hub</option>
              </select>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4 mb-3">
              <label htmlFor="country" className="form-label">Country <span className="text-danger">*</span></label>
              <Select
                id="country"
                options={countries}
                onChange={handleCountryChange}
                value={countries.find(option => option.value === country)}
                isClearable
                placeholder="Select Country"
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="state" className="form-label">State <span className="text-danger">*</span></label>
              <Select
                id="state"
                options={states}
                onChange={handleStateChange}
                value={states.find(option => option.value === state)}
                isClearable
                placeholder="Select State"
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="city" className="form-label">City <span className="text-danger">*</span></label>
              <Select
                id="city"
                options={cities}
                onChange={handleCityChange}
                value={cities.find(option => option.value === city)}
                isClearable
                placeholder="Select City"
                required
              />
            </div>


          </div>

          <div className="row mb-2">
            <div className="col-md-4 mb-3">
              <label htmlFor="location" className="form-label">Location <span className="text-danger">*</span></label>
              <input
                type="text"
                id="location"
                className="form-control"
                value={location}
                onKeyDown={(e) => {
                  if ([
                    '+', '-', '.', '=', '_', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')',
                    '[', ']', '{', '}', '|', '/', '?', '<', '>', ',', '`', '~', "'", '"', ':', ';', '\\',
                    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
                  ].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setLocation(e.target.value.trimStart())}
                required
              />
            </div>

          </div>
          <div className="d-flex justify-content-end gap-5 mt-3">
            <Link className="btn btn-primary w-auto" to="/hubtable">
              Cancel
            </Link>
            <button type="submit" className="btn btn-primary w-auto" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>

          <ToastContainer />
        </form>
      </div>

      {success && (
        <div className='modal-backdrop shadow-lg rounded-5'>
          <div className='modal fade show d-block' tabIndex={-1} role='dialog'>
            <div className='modal-dialog modal-dialog-centered' role='document'>
              <div className='modal-content pb-10 pt-4'>
                <div className='modal-header py-2 d-flex justify-content-end' style={{ cursor: "pointer" }}>
                  <span onClick={() => setSuccess(false)}>🗙</span>

                </div>
                <div className='text-center'>
                  <img alt='Logo' src={toAbsoluteUrl('/media/illustrations/sigma-1/12-dark.png')} className='w-250px mb-6 runningImage' />
                  <h2>Hub created successfully!</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HubPoint;
